<ng-container *transloco="let t; read: 'stats.filter-period'">
  <div class="flex flex-row space-x-4 place-content-end">
    <stats-date-range-picker
        [state]="period$ | async"
        (stateChanged)="periodStateChanged($event)"
        [disabled]="isLoading$ | async">
    </stats-date-range-picker>

    <mat-form-field class="w-72 fuse-mat-no-subscript">
      <mat-select [value]="selectedTenant$ | async" placeholder="Filtrar por cliente"
                  (selectionChange)="selectClient($event.value)"
                  [compareWith]="compareTenant">
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Pesquise o cliente" [formControl]="filterCtrl">
            <div ngxMatSelectNoEntriesFound class="flex justify-between">
              <span>Nenhum registro encontrado</span>
              <mat-progress-spinner *ngIf="loading$ | async" mode="indeterminate" [diameter]="32"
                                    color="primary"></mat-progress-spinner>
            </div>
          </ngx-mat-select-search>
        </mat-option>

        <mat-option *ngFor="let item of tenants$ | async" [value]="item">
          {{ item.name }}
        </mat-option>

        <ng-container *ngIf="!!(selectedTenant$ | async)">
          <mat-option [value]="null">
            Limpar
          </mat-option>
        </ng-container>
        
      </mat-select>
    </mat-form-field>
  </div>
</ng-container>